<template>
  <div class="document-summary">
    <p class="document-summary-title">{{bookName}}</p>
    <p class="document-summary-text">日付や発翰番号、出典などから検索して閲覧いただけます。<br>また、目次から閲覧いただくこともできます。</p>
    <p class="document-summary-text">ご利用方法の詳細は<a :href="url" target="_blank">こちら</a>をご覧ください。</p>
  </div>
</template>
<script>
import { defineComponent, reactive, computed } from '@vue/composition-api'
export default defineComponent({
  name: 'PCDocumentPartSummary',
  props: {
    bookName: {
      type: String
    },
    url: {
      type: String
    }
  },
  setup (props) {
    return {
      props
    }
  }
})
</script>
